import React from 'react';
import { setAiSidebarMode } from '../../actions/aiActions';
import { useDispatch, useSelector } from 'react-redux';
import styles from './AiAssistantLauncher.module.css';
import SparklesIcon from './SparklesIcon';

const AiAssistantLauncher = () => {
  const dispatch = useDispatch();
  const aiSidebarMode = useSelector(state => state.aiReducer.aiSidebarMode);
  const isSidebarOpen = aiSidebarMode !== 'closed';

  const handleToggle = () => {
    const newMode = isSidebarOpen ? 'closed' : 'compact';
    dispatch(setAiSidebarMode(newMode));
  };

  const buttonClasses = `${styles.button} ${
    isSidebarOpen ? styles.buttonActive : ''
  }`;
  const starsWrapperClasses = `${styles.starsWrapper} ${
    isSidebarOpen ? styles.active : ''
  }`;

  return (
    <div style={{ display: 'inline' }}>
      <button
        type='button'
        onClick={handleToggle}
        id='aiAssistantLauncherButton'
        className={buttonClasses}
      >
        <SparklesIcon
          isActive={isSidebarOpen}
          size={20}
          className={styles.sparkles}
        />

        {/* 3. The star elements are always rendered, but hidden/shown with CSS opacity */}
        <div className={starsWrapperClasses}>
          <div className={`${styles.stars} ${styles.stars1}`} />
          <div className={`${styles.stars} ${styles.stars2}`} />
          <div className={`${styles.stars} ${styles.stars3}`} />
        </div>
      </button>
    </div>
  );
};

export default AiAssistantLauncher;
